var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlots = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1254 1H2.87463C1.84094 1 1 1.84094 1 2.87463V14.1255C1 15.1591 1.84094 16 2.87463 16H14.1255C15.1591 16 16 15.1591 16 14.1254V2.87463C16 1.84094 15.1591 1 14.1254 1ZM12.9306 5.47909C10.1112 7.49303 10.5139 12.7292 10.5139 12.7292H5.68056C5.68056 9.90972 9.70834 7.09019 9.70834 7.09019C8.90275 7.49294 7.85894 7.70078 7.29166 7.49294C5.25494 6.74688 5.27772 8.29853 5.27772 8.29853H4.06938V4.27075H5.27772V5.07634H5.43878C6.40544 4.02906 8.85588 4.32381 9.3055 4.67359C10.0306 5.2375 12.1249 5.07634 12.9305 4.67359L12.9306 5.47909Z",
    fill: "#CCD6F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlots);
export default ForwardRef;